import { useState } from "react";
import { TaskCard } from "./TaskCard";

const placeAt = (ids, dragId, targetId, before) => {
  const rest = ids.filter((x) => x !== dragId);
  rest.splice(rest.indexOf(targetId) + (before ? 0 : 1), 0, dragId);
  return rest;
};

const swap = (ids, i, j) => {
  const next = [...ids];
  [next[i], next[j]] = [next[j], next[i]];
  return next;
};

export const SortableList = ({ tasks, h, cardProps = () => ({}) }) => {
  const [hint, setHint] = useState(null);
  const ids = tasks.map((t) => t.id);
  const canMove = tasks.length > 1;

  return tasks.map((t, i) => {
    const onDragOver = (e) => {
      const r = e.currentTarget.getBoundingClientRect();
      setHint({ id: t.id, before: e.clientY < r.top + r.height / 2 });
    };
    const onDrop = (e) => {
      const dragId = e.dataTransfer.getData("text/plain");
      const before = hint?.before ?? true;
      setHint(null);
      if (!ids.includes(dragId)) return;
      // Same list: reorder here, the container must not move the task
      e.nativeEvent.reorderHandled = true;
      if (dragId !== t.id) h.reorder(placeAt(ids, dragId, t.id, before));
    };
    const reorder = canMove && {
      up: i > 0 ? () => h.reorder(swap(ids, i, i - 1)) : null,
      down: i < ids.length - 1 ? () => h.reorder(swap(ids, i, i + 1)) : null,
    };
    let hintClass = "";
    if (hint?.id === t.id) hintClass = hint.before ? "drop-before" : "drop-after";
    return (
      <div key={t.id} className={`sortable-item ${hintClass}`} onDragOver={onDragOver} onDragLeave={() => setHint(null)} onDrop={onDrop}>
        <TaskCard task={t} h={h} reorder={reorder} {...cardProps(t)} />
      </div>
    );
  });
};
